const ROOTS_LANDING = "/";
export const PATH_LANDING = {
  root: ROOTS_LANDING,
};
const PATH_SEGURIDAD = {
  auth: "seguridad/auth/",
  usuarios: "seguridad/users/",
  modulos: "seguridad/modulos/",
  rutas: "seguridad/rutas/",
  perfiles: "seguridad/perfiles/",
};

const PATH_VENTAS = {
  cotizacion: "ventas/cotizacion/",
  comprobantepago: "ventas/comprobantepago/",
  terminalcajero: "ventas/terminalcajero/",
  pedidoventa: "ventas/pedidoventa/",
};
const PATH_RECURSOSHUMANOS = {
  empleados: "rrhh/empleados/",
};
const PATH_ENTIDADES = {
  proveedores: "entidades/proveedores/",
  personas: "entidades/personas/",
  contactos: "entidades/contactos/",
  clientes: "entidades/clientes/",
};
const PATH_MAESTROS = {
  item: "maestros/productos/",
  unidadmedida: "maestros/unidadesmedida/",
};

const PATH_INVENTARIOS = {
  inventario: "inventarios/inventario/",
  inventarioinicial: "inventarios/inventarioinicial/",
  movimientoentrada: "inventarios/movimientoentrada/",
  movimientosalida: "inventarios/movimientosalida/",
  movimientotraslado: "inventarios/movimientotraslado/",
  comprobantemovimiento: "inventarios/comprobantemovimiento/",
  periodocontable: "inventarios/periodocontable/",
};
const PATH_PRODUCCION = {
  maquina: "produccion/maquina/",
  tareaproduccion: "produccion/tareaproduccion/",
  rutaproduccion: "produccion/rutaproduccion/",
  ordenproduccion: "produccion/ordenproduccion/",
  procesoproduccion: "produccion/procesoproduccion/",
  programaciontejido: "produccion/programaciontejido/",
  programaciontintoreria: "produccion/programaciontintoreria/",
  movimientotraslado: "movimientotraslado/",
  consolidadotela: "produccion/consolidadotela/",
  resumenproduccion: "produccion/resumenproduccion/",
};
const PATH_CAJAS = {
  caja: "cajas/caja/",
  aperturacajas: "ventas/aperturacajas/",
  arqueocaja: "ventas/arqueocaja/",
  movimientoscaja: "ventas/movimientocaja/",
  naturalezapagocaja: "ventas/naturalezapagocaja/",
};
export {
  PATH_SEGURIDAD,
  PATH_VENTAS,
  ROOTS_LANDING,
  PATH_RECURSOSHUMANOS,
  PATH_ENTIDADES,
  PATH_MAESTROS,
  PATH_INVENTARIOS,
  PATH_PRODUCCION,
  PATH_CAJAS,
};
